export * from "./SocialMediaLink.type";
